// @ts-check

import BaseComponent from "../../../js/base-component";

class Sidebar extends BaseComponent {
    constructor(options) {
        super(options);

        let sidebarTrigger = document.querySelector(".u-sidebar--trigger"),
            sidebar = document.querySelector(".u-sidebar"),
            subnavs = document.querySelectorAll(".u-navigation__item.has--subnav"),
            closeSubnavs = document.querySelectorAll(".u-navigation__item.back"),
            overlay = document.querySelector(".js--overlay"),
            body = document.querySelector("body"),

        //methods
        setup = function () {
            sidebarTrigger.addEventListener("click", open);
            subnavs.forEach((element) => { element.addEventListener("click", openSubnav); } );
            closeSubnavs.forEach((element) => { element.addEventListener("click", closeSubnav); } );
        },
        close = function (evt) {
            evt.preventDefault();

            sidebar.classList.remove("is--open");
            overlay.classList.remove("is--open");
            body.classList.remove("no--scroll");
            sidebarTrigger.removeEventListener("click", close);
            sidebarTrigger.addEventListener("click", open);
            document.removeEventListener("click", globalclose);
        },
        globalclose = function (evt) {
            if ( !sidebar.contains(evt.target) && !sidebarTrigger.contains(evt.target) ) {
                evt.preventDefault();

                close(evt);
            }
        },
        open = function (evt) {
            evt.preventDefault();

            sidebar.classList.add("is--active","is--open");
            overlay.classList.add("is--open");
            body.classList.add("no--scroll");
            sidebarTrigger.removeEventListener("click", open);
            sidebarTrigger.addEventListener("click", close);
            document.addEventListener("click", globalclose);
        },
        openSubnav = function(evt) {
            evt.stopPropagation();

            let parent = evt.target.parentElement || '';
            if ( parent && parent.classList.contains("has--subnav") ) {
                evt.preventDefault();

                parent.children[0].classList.add("is--active");
                setTimeout(function(){
                    parent.children[0].classList.add("is--open");
                },1);
            }
        },
        closeSubnav = function(evt) {
            evt.preventDefault();

            let parent = evt.target.parentElement || '';

            if ( parent && parent.classList.contains("back") ) {
                parent.parentNode.parentNode.classList.remove("is--open");
                setTimeout(function(){
                    parent.parentNode.parentNode.classList.remove("is--active");
                },400);
            }
        };

        if (sidebarTrigger) {
            setup();
        }
    }
}

export default {
    definition: Sidebar,
    name: "Sidebar",
};